import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import {default as Reactsel} from 'react-select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'

class TpoRegistrationStatus extends Component{
	constructor(props) {
    	super(props)
    	this.state = {
        errorMsg: '',
    		data: {
    			registration_info: [],
    			phone: ''
    		}
    	}
    }

    handleFetchData = (event) => {
        return api.tpoRegistrationStatus(this.props.user.accessToken, this.state.data.phone)
		    .then((result) => {
		      if (result.status === "success") {
		        let data = Object.assign({}, this.state.data)
		        data.registration_info = result.data
		        this.setState({data: data})
		      }
		    })
		    .catch((err) => {
		    // console.log(`error:${err.stack}`)
		      
		      this.setState({ message: err.stack })
		    })
    }

    onInputChange = evt => {
	    const data = Object.assign({}, this.state.data);
	    data[evt.target.name] = evt.target.value;
	    this.setState({data});
	  };

    componentDidMount() {
        
    }

    render() {
    	let registrationInfoListCompnent
    	if(this.state.data.registration_info.length >0){
      registrationInfoListCompnent = 
        ( <tbody>
            {this.state.data.registration_info.map(regUser => (

              <tr>
                <td>{regUser.id}</td>
                <td>{regUser.email}</td>
                <td>{regUser.phone}</td>
                <td>{regUser.first_name}</td>
                <td>{regUser.last_name}</td>
                <td>{regUser.registration_status}</td>
                <td>{regUser.payment_status}</td>
              </tr>
            ))}
          </tbody>  
        )
     	}
    	return (
    		<Grid>
      		<GridCell span="12">
      			<Card style={{padding: '25px'}}>
            		<Typography use="headline5">TPO Registration Status</Typography>
          		</Card>
          	</GridCell>
          	<GridCell span="12">
          	<TextField
						  textarea
						  fullwidth
              placeholder="Please enter phone numbers separated by comma ( , )"
						  rows={4}
						  maxLength={70000}
						  characterCount
						  name='phone'
						  onChange={this.onInputChange}
						  helpText={{
						    persistent: true,
						    validationMsg: true,
						    children: 'The field is required'
						  }}
						/>
						</GridCell>
						<GridCell span="6">
          	<Button onClick={this.handleFetchData}>Fetch data</Button>
          	</GridCell>
          	<GridCell span="12">
          		<div>
	              <table className="admin-table">
	                <th>User Id</th>
	                <th>Email</th>
	                <th>Phone</th>
	                <th>First Name</th>
	                <th>Last Name</th>
	                <th>Registration Status</th>
	                <th>Payment Status</th>
	                {registrationInfoListCompnent}
	              </table>
            	</div>
          	</GridCell>
        </Grid>
    	)
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TpoRegistrationStatus);


// WEBPACK FOOTER //
// ./src/views/admin/TpoRegistrationStatus.jsx